module.exports = __webpack_public_path__ + "static/media/fold-constraint.ceaf9cba.png";